import Button from "react-bootstrap/esm/Button";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
    const navigate = useNavigate();

    return <>
        <h4 className="text-center">Åtkomst nekad</h4>
        <p className="text-center">Ni har inte behörighet att besöka denna sida. Kontakta support om ni behöver hjälp</p>
        <div className="text-center"><Button variant="outline-primary" onClick={() => navigate("/")}>Hem</Button></div>
    </>
}

export default AccessDenied;